import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Funnel} from '../../models/cms/funnel/funnel';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class FunnelService extends AbstractModelService<Funnel> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/funnel', Funnel);
  }

  duplicate(id: number): Observable<any> {
    return new Observable<any>((subscriber: Subscriber<any>): void => {
      this.apiClient.post(this.routePath + '/' + id + '/duplicate', {}, {}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  fetchUrlVariables(): Observable<string[]> {
    return new Observable<string[]>((subscriber) => {
      this.apiClient.get('/funnel/url/variables').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData()['variables']);
          subscriber.complete();
        }, error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
